import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import Typography from '@ts-core/components/Typography';

import StudentAssignmentCard from '@ts-core/modules/assignments/components/StudentAssignmentCard';

import { StudentAssignment } from '@ts-core/modules/assignments/types';

interface StudentAssignmentSectionListProps {
  assignments?: StudentAssignment[];
  loading?: boolean;

  title: React.ReactNode;
  onSelectAssignment?: (assignment: StudentAssignment) => void;
}

const StudentAssignmentSectionList = (props: StudentAssignmentSectionListProps) => {
  const { title, assignments, onSelectAssignment } = props;

  return (
    <Grid container spacing={1} style={{ marginTop: 16 }}>
      <Grid item xs={12}>
        <Typography variant="subtitle2" style={{ marginLeft: 16 }}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={0}>
          {assignments?.map((a, index) => (
            <Grid item xs={12} key={a.id}>
              <StudentAssignmentCard assignment={a} onAssignmentClick={onSelectAssignment} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

StudentAssignmentSectionList.propTypes = {
  title: PropTypes.node,
  assignments: PropTypes.array,
  disableDoAssignment: PropTypes.bool,

  onSelectAssignment: PropTypes.func,
};

StudentAssignmentSectionList.defaultProps = {
  title: '',
  assignments: [],
  disableDoAssignment: false,

  onSelectAssignment() {},
};

export default StudentAssignmentSectionList;
